import 'normalize.css'
import './src/common/styles/global.scss'

export const onClientEntry = () => {
    document.title = 'First Aid Made Simple | MW-Training'
}
